enum DocumentActionHistoryType {
    Approved = 1,
    Revoked = 2
}

interface IDocumentActionHistory {
    Id: string;
    DocumentId: string;
    ActionType: DocumentActionHistoryType;
    PerformedAtDate: Date;
    PerformedByContactId: string;
}

export { DocumentActionHistoryType, IDocumentActionHistory };
